import './marketing-label.scss';
